import { render, staticRenderFns } from "./HomeGroups.vue?vue&type=template&id=0f7e155e&"
import script from "./HomeGroups.vue?vue&type=script&lang=js&"
export * from "./HomeGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports